import { PetOwnerEffects } from './consultation-pet-owner.effects';
import { ConsultationCreateEffects } from './consultation-create.effects';
import { ConsultationVetSourceEffect } from './consultation-vetsource.effects';

export const ConsultationEffects = [ConsultationCreateEffects, PetOwnerEffects, ConsultationVetSourceEffect];
